import { useRef } from 'react';

/**
 * What you had seen of the game before this visit, from the server (`seen`, SeenMoves) as the game first loaded:
 * the version you last saw and how many of the other player's moves came after it. It stays put while you're here,
 * so catching up and the Replay button start from where you left off.
 *
 * @returns {{ seenVersion: ?number, newMoves: number }|null} null until the game has loaded
 */
export default function useSeenBefore(game) {
  const before = useRef(null);
  if (game && before.current === null) {
    before.current = {
      seenVersion: game.getIn(['seen', 'seen_version']) ?? null,
      newMoves: game.getIn(['seen', 'new_moves']) || 0,
    };
  }
  return before.current;
}
